var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSwimming40PxSelected = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "swimming",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 58,
    viewBox: "0 0 40 58",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 55,
    r: 3,
    fill: "#FF2E00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,48,34.142,33.521a19.531,19.531,0,0,0,5.474-10.054,19.315,19.315,0,0,0-1.138-11.345,19.725,19.725,0,0,0-7.367-8.813,20.309,20.309,0,0,0-22.222,0,19.725,19.725,0,0,0-7.367,8.813A19.315,19.315,0,0,0,.384,23.467,19.531,19.531,0,0,0,5.858,33.521Z",
    fill: "#FF2E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(12.5,12.5)",
    fill: "#ffffff",
    id: "path16388",
    d: "M10.1113,2C9.9989,2,9.6758,2.1465,9.6758,2.1465L6.3535,3.8262 C5.9111,4.0024,5.7358,4.7081,6.002,5.0605l0.9707,1.4082L3.002,8.498L5,9.998l2.502-1.5l2.5,1.5l1.002-1.002l-3-4l2.5566-1.5293 c0.5286-0.2662,0.4434-0.7045,0.4434-0.9707C10.9999,2.2861,10.6437,2,10.1113,2z M12.252,5C11.2847,5,10.5,5.7827,10.5,6.75 s0.7847,1.752,1.752,1.752s1.75-0.7847,1.75-1.752S13.2192,5,12.252,5z M2.5,10L0,11.5V13l2.5-1.5L5,13l2.502-1.5l2.5,1.5L12,11.5 l3,1.5v-1.5L12,10l-1.998,1.5l-2.5-1.5L5,11.5L2.5,10z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSwimming40PxSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/swimming_40px_selected.2c3f2a4fb9b3da4638b9e89fcf0b5a1c.svg";